import React from 'react';

const Cancel = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold text-red-500">Payment Cancelled</h1>
      <p>Your payment was cancelled.</p>
    </div>
  );
};

export default Cancel;
